import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import PriceRange from "./priceRange";
import { useAppDispatch, useAppSelector } from "../../../../../reduxToolkit/hooks";
import { dynamicImage } from "../../../../../utils";
import { Filters } from "../../../../../constants";
import { setSideBarOn } from "../../../../../reduxToolkit/reducers/eCommerce/filterSlice";
import Categories from "./categories";
import SearchBar from "./SearchBar";
import { Image } from "../../../../../coreComponents/Image";

// This component displays a filter sidebar with categories, price range, and a banner image.
const Sidebar = () => {
  const dispatch = useAppDispatch();
  const { isFilter } = useAppSelector((state) => state.filterData);

  return (
    <Row>
      <Col sm="3">
        <div className={`product-sidebar ${isFilter ? "open" : ""}`}>
          <div className="filter-section">
            <Card>
              <CardHeader onClick={() => dispatch(setSideBarOn())}>
                <h6 className="mb-0">
                  {Filters}
                  <span className="pull-right">
                    <i className="fa fa-chevron-down toggle-data"/>
                  </span>
                </h6>
              </CardHeader>
              <div className="left-filter custom-scrollbar z-1">
                <CardBody className="filter-cards-view custom-scrollbar animate-chk">
                  <Categories />
                  <PriceRange />
                  <div className="product-filter text-center">
                    <Image className="img-fluid banner-product" src={dynamicImage(`ecommerce/banner.jpg`)} alt="" />
                  </div>
                </CardBody>
              </div>
            </Card>
          </div>
        </div>
      </Col>
      <SearchBar />
    </Row>
  );
};

export default Sidebar;